import * as React from 'react';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { FlexColumn, SectionBody } from '@portal/common/components';
import { styled } from '@portal/common/theme';
import { RefinementFilterConfig } from '@portal/common/types';

import DataCollectionSelector from '../../components/DataExplorer/DataCollectionSelector';
import LimitWarnings from '../../components/LimitWarnings';
import { getDataToolConfig } from '../../store/data-explorer/selectors';
import EDPConditionSelector from './EDPConditionSelector';
import EDPRefinementFiltersControls from './EDPRefinementFiltersControls';

const StyledSectionBody = styled(SectionBody)(({ theme }) => ({
    marginTop: 0,
}));

type Props = {
    refinementFiltersConfig?: RefinementFilterConfig;
    areChartsVisible: boolean;
    toggleChartsVisibility: () => void;
};

const EDPSelectDataSection: FC<Props> = ({
    refinementFiltersConfig,
    toggleChartsVisibility,
    areChartsVisible,
}) => {
    const dataToolConfig = useSelector(getDataToolConfig);

    const isDataCollectionSelectorVisible = dataToolConfig?.dataCollectionSelectorVisibility;

    return (
        <StyledSectionBody>
            <FlexColumn>
                {isDataCollectionSelectorVisible && <DataCollectionSelector />}
                <EDPConditionSelector />
                <EDPRefinementFiltersControls
                    refinementFiltersConfig={refinementFiltersConfig}
                    {...{ toggleChartsVisibility, areChartsVisible }}
                />
            </FlexColumn>
            <LimitWarnings />
        </StyledSectionBody>
    );
};

export default EDPSelectDataSection;
